import React from 'react';

import './Icon.css';

const Icon = (props) => {
    const { src = '', alt = '', className, ...restProps } = props;

    const attributes = {
      className: 'form-icon-parent' + (className ? ' ' + className : ''),

      ...restProps,
    };

    const imgAttributes = {
      className: 'form-icon',

      src,
      alt,
    };

    return (
      <div {...attributes}>
        <img {...imgAttributes} alt="" />
      </div>
    )
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/forms/Icon.js